
// * ========================================================================
// * dead chart
// * ========================================================================

import CovidChart from './covid-chart.js';
import moment from 'moment';

const deadCumulative = (function(){

    let thisChart = null;
    let chartData = null;
    const lag = -(8*7);
    let delay = moment().add(lag, 'day').format('YYYY-MM-DD');

    function createChartData(data, options) {
        let datasets = [{
            label: 'Kuolintodistuksessa',
            id: 'all',
            type: 'LineWithLine',
            borderColor: '#444444',
            labelColor: '#000',
            borderWidth: 3,
            count: 0,
            fill: false,
            data: [],
            pointRadius: 0,
            yAxisID: 'y',
            order: 0,
            selected: true,
            stack: 'dead'
        }, {
            label: 'Kuolemaan myötävaikuttanut',
            id: 'dead-with',
            borderColor: 'rgb(0, 0, 0, 0.01)',
            backgroundColor: 'rgb(0, 0, 0, 0.2)',
            labelColor: '#666',
            borderWidth: 3,
            fill: 2,
            selected: true,
            data: [],
            pointRadius: 0,
            pointHoverRadius: 5,
            type: 'LineWithLine',
            order: 1,
            stack: 'Stack 1'
        },
        {
            label: 'Pääkuolinsyy',
            id: 'dead-due',
            borderColor: 'rgb(0, 0, 0, 0.01)',
            backgroundColor: 'rgb(0, 0, 0, 0.4)',
            labelColor: '#444',
            borderWidth: 3,
            fill: 'origin',
            selected: true,
            data: [],
            pointRadius: 0,
            pointHoverRadius: 5,
            type: 'LineWithLine',
            order: 0,
            stack: 'Stack 1'
        },
        {
            label: 'Ajallisesti liittyvä',
            id: 'deaths',
            type: 'LineWithLine',
            borderColor: '#e80a9a',
            borderWidth: 3,
            labelColor: '#e80a9a',
            //backgroundColor: 'rgba(232, 10, 154, 0.2)',
            count: 0,
            fill: false,
            data: [],
            pointRadius: 0,
            yAxisID: 'y',
            borderDash: [6,6],
            order: 1,
            selected: true,
            stack: 'dead-time'
        }];

        // Create data
        for (let item of data.dead.days) {
            const date = moment(item.date);

            if (item.countTotalTimeRelated > 0 || item.countTotal > 0) {
                datasets[0].data.push({
                    x: date,
                    y: item.countTotal
                });

                datasets[1].data.push({
                    x: date,
                    y: item.countTotalContributing
                });

                datasets[2].data.push({
                    x: date,
                    y: item.countTotalLeading
                });

                datasets[3].data.push({
                    x: date,
                    y: item.countTotalTimeRelated
                });
            }
        }

        return datasets;
    }

    /**
     * Initialize
     *
     * @param {Object} data - covid data
     * @param {Object} options - chart options
     */
    function init(data, options) {
        chartData = data;

        const datasets = createChartData(chartData, window.config);

        thisChart = new CovidChart('dead-cumulative-chart', {
            datasets,
            chartOptions: {
                type: 'line',
                options: {
                    plugins: {
                        tooltip: {
                            intersect: false,
                            position: 'nearest',
                            bodySpacing: 5,
                        },
                    },
                    scales: {
                        x: {
                            type: 'time',
                            time: {
                                unit: 'day',
                                displayFormats: {
                                    day: 'D.M.YY',
                                }
                            }
                        },
                        y: {
                            stacked: true,
                            min: 0,
                            type: 'linear',
                            position: 'left'
                        }
                    },
                }
            },
            config: window.config,
            tooltips: {
                elementId: 'dead-cumulative-chart-tooltip'
            },
            multiselect: {
                requireCount: false,
                valueType: 'string',
                idField: 'id',
                colorField: 'labelColor',
                inputName: 'dead-cumulative-multiselect',
                selectElemId: 'dead-cumulative-multiselect',
                colorElemId: 'dead-cumulative-multiselect-colors',
                dropdownId: 'dead-cumulative-multiselect-dropdown',
                countElemId: 'dead-cumulative-multiselect-count'
            }
        });
    }

    function reload(data = null) {
        if (data) {
            chartData = data;
        }

        // Update data
        const datasets = createChartData(chartData, window.config);

        // Update datasets
        thisChart.updateDatasets(datasets, true);
    }

    return {
        init,
        reload
    }

})();

export default deadCumulative;
